export default __webpack_public_path__ + "static/media/43.a7018801.png";